import { Component } from '@angular/core';
import {DoraChartTypeSettingComponent} from '../dora-chart-type-setting.component';
import {CHART_TYPE} from '../../../DoraData/data-base';


@Component({
  selector: 'dora-chart-type-setting-lb',
  templateUrl: './dora-chart-type-setting-lb.component.html',
  styleUrls: ['./dora-chart-type-setting-lb.component.scss']
})
export class DoraChartTypeSettingLbComponent extends DoraChartTypeSettingComponent {

  // ChartTypeList
  public chartTypeLista: Array<any> = [];
  public selectedItem: Array<any> = [];

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    this.chartTypeLista = [];
    this.selectedItem = [];
    this.chartTypeElements.forEach(chartTypeElement => {
      // tslint:disable-next-line:max-line-length
      const selectElement = {id: `${chartTypeElement.Type}`, text: `<div class="DAG-img-select ${CHART_TYPE[chartTypeElement.Type]}" ></div>${chartTypeElement.description}`};
      // style="width: 10px; height: 10px; background-color: red; display: inline-block;"
      this.chartTypeLista.push(selectElement);
      if (chartTypeElement.FlActive) {
        this.selectedItem.push(selectElement);
      }
    });
  }
  public selected(value: any): void {
    console.log('Selected value is: ', value);
    const chartTypeSelected: CHART_TYPE = Number(value.id);
    this.activeChartType(chartTypeSelected);

    // let dataRow: DataRow;
    // dataRow = this.dataGrid.getDataRow(value.id);
    //
    // if (dataRow === null) {
    //   console.error('Row not found. Id: ' + value.id);
    //   return;
    // }
    //
    // this.messageService.sendMessage(this.EventChannel, new MessageGridSelected(dataRow.GridId));
  }

  public removed(value: any): void {
    console.log('Removed value is: ', value);
  }

  public typed(value: any): void {
    console.log('New search input: ', value);
  }

  public refreshValue(value: any): void {
    console.log('Typed: ', value);
  }
}
